import {Suspense, lazy} from 'react'
import Loader from "../../customs/loader/main"

const Main = lazy(() => import("../../components/settings/Setups/electionGuidelines/main"))

const ElectionGuideline = () => {
  return (
    // <Layout >
        <Suspense fallback={<Loader />}> 
        <Main />
    </Suspense>
    // </Layout>
    
  )
}

export default ElectionGuideline